module.exports = __webpack_public_path__ + "static/media/ticket.e21ef50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/ticket.png
// module id = 931
// module chunks = 2